import { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';


import api from 'shared/topchef-api-places';
import { NotificationType, PublicLead } from 'shared/topchef.types'

import { NotificationContext } from 'shared/NotificationContext'
import Loading from 'pages/shared/loading/Loading'
import MoreDetailsCellRenderer from "pages/shared/more-details-renderer/MoreDetailsCellRenderer"
import BriefsMarketMenu from 'pages/places/briefs-market-menu/BriefsMarketMenu';
import { useErrorBoundary } from 'react-error-boundary';
import BriefsList from 'pages/shared/briefs-list/BriefsList'
import { useOutletContext } from 'react-router';
import { PlaceOutletContextType } from '../home/PlacesHome';


const AvailableLeads = () => {

  const { t } = useTranslation();
  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();
  
  const [leadsLoaded, setLeadsLoaded] = useState<boolean>(false);
  const [availableLeads, setAvailableLeads] = useState<PublicLead[]>([]);
  const [onlyMatchingLeads, setOnlyMatchingLeads] = useState<boolean>(true);
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const { showBoundary } = useErrorBoundary();

  const loadPublicLeads = useCallback( async () => { // eslint-disable-line react-hooks/exhaustive-deps
    
    try {
      
      var leads: PublicLead[];
      if (onlyMatchingLeads) {
        leads = await api.loadAvailableLeadsMatchingMyCriteria(loggedInPlace!.id);
      } else {
        leads = await api.loadAllAvailableLeads(loggedInPlace!.id);
      }
       
      setAvailableLeads(leads);
      setLeadsLoaded(true);
    } catch (error: any) { 
      const newError = new Error(t('apiErrors.loadAvailableLeads', { details: error.message }) as string);
      triggerNotification({type: NotificationType.error, message : newError.message});
      return showBoundary(newError);
    } 
  }, [onlyMatchingLeads, loggedInPlace, triggerNotification, showBoundary]); // eslint-disable-line react-hooks/exhaustive-deps



  useEffect(() => {
    if (leadsLoaded) {
      return;
    }
    loadPublicLeads();
  }, [loadPublicLeads, leadsLoaded]);


  const moreDetailsRenderer = (params: any) => {
    const leadId: string = params.data.id;
    return (
      <MoreDetailsCellRenderer url={`/places/available-leads/${leadId}`} label={t('actionLabels.moreDetails')}  />
    );
  };


  const reloadLeads = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOnlyMatchingLeads(event.target.checked);
    setLeadsLoaded(false);
  };

  if (!leadsLoaded) {
    return (
      <Loading />
    );
  }


  return (
    <div className="page-briefs-market container p-5">
      <div id="lead_sidebar" className="d-flex">
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">{t('common.addBrief')}</a></li>
        </ul>
      </div>

      <h5 className="mb-3">{t('nav.availableBriefs')}</h5>

      <BriefsMarketMenu loggedInPlace={loggedInPlace}/>


      <form>

        <div className="mb-3 m-0">
          <div className="form-check form-switch">
            <label className="form-check-label" htmlFor="matchingCriteriaFilter">{t('availableLead.filterLabel')}</label>
            <input className="form-check-input" type="checkbox" role="switch" id="matchingCriteriaFilter" data-testid="matchingCriteriaFilter" defaultChecked={onlyMatchingLeads} onChange={reloadLeads}/>
          </div>
        </div>

      </form>

      <BriefsList leads={availableLeads} detailsRenderer={moreDetailsRenderer} paginateResults={true} height='80%'/>

    </div>
  );


}

export default AvailableLeads;
